import {FloteEndpointGroup} from "@/lib/api/endpoints/FloteEndpointGroup";

export class VehiclesApi extends FloteEndpointGroup {
    public relativeUri: string = "vehicles";
}
